import { CascadeSelectValue } from '../pill-select/PillSelect'

export const isCascadeSelectValue = (
  value: CascadeSelectValue | string
): value is CascadeSelectValue => {
  return typeof value === 'object'
}

export const isCascadeSelectValues = (
  values: readonly (string | CascadeSelectValue)[]
): values is ReadonlyArray<CascadeSelectValue> => {
  return isCascadeSelectValue(values[0])
}

export const getStringValue = (value: CascadeSelectValue | string): string =>
  isCascadeSelectValue(value) ? value.value : value
